export class Link {
  constructor(name = 'item', href = '#', className = '') {
    this.name = name;
    this.href = href;
    this.className = className;
  }
}
